// Port of api/fuel/app/classes/filter/search/games/sorts/post/play/plays/winpercent.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { sorted, sortReverse } from 'offline/filter/core/search/unit'

export default {
	name: 'post.sort.play.plays.winpercent',
	post: true,
	sorts: function(config) {
		return config.resultType === F.RESULT_GAME ? ['plays.winpercent'] : []
	},
	modifies: function() {
		return 'index'
	},
	require: function(config, filter) {
		return config.ownerType === F.OWNER_USER && config.resultType === F.RESULT_GAME && sorted('plays.winpercent', filter) > 0
	},
	run: function(config, filter, data, results) {
		if (!results.games || !results.games.length) return results

		var sql = 'SELECT game_id, COUNT(play_id) as plays, SUM(play_won) as wins FROM play WHERE play_result = 1 AND game_id IN(' + Util.in(results.games) + ') AND user_id = ' + config.userID
		if (results.concat && results.concat.p && results.concat.p.length) {
			sql += ' AND play_id IN(' + Util.in(results.concat.p) + ')'
		}
		sql += ' GROUP BY game_id'

		var rows = DB.query(sql)
		var stats = Util.keyed_array(rows, 'game_id')
		var reverse = sortReverse('plays.winpercent', filter)

		results.games.sort(function(a, b) {
			var sa = stats[a], sb = stats[b]
			var pa = sa && sa.plays ? (100 / sa.plays) * sa.wins : 0
			var pb = sb && sb.plays ? (100 / sb.plays) * sb.wins : 0
			return reverse ? pb - pa : pa - pb
		})

		var gameOrder = {}
		for (var i = 0; i < results.games.length; i++) gameOrder[results.games[i]] = i
		results.index.sort(function(a, b) {
			var ga = results.mapIndex ? results.mapIndex[a] : a
			var gb = results.mapIndex ? results.mapIndex[b] : b
			return (gameOrder[ga] || 0) - (gameOrder[gb] || 0)
		})

		return results
	}
}
